import React from 'react';

import {
  BaseWidget,
  LabelledText,
  NetSuiteRecordChip
} from 'modules';

import * as dataService from './dataService';
import { Grid } from '@mui/material';



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);

  return (
    <BaseWidget.FC title="RMA Source Information">
      <Grid container>
        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="Client"
            text={queryTuple.data.returnAuthorization?.clientName} />

          <LabelledText.FC
            title="Pre-alert date"
            text={queryTuple.data.returnAuthorization?.dateReceived?.toFormat('MM/dd/yy') ?? 'N/A'} />

          <LabelledText.FC
            title="RMA Number"
            text={(
              <NetSuiteRecordChip.FC writeStatus={queryTuple.data.returnAuthorization?.netSuiteRecord ?? { type: 'pending' }} />
            )} />


          <LabelledText.FC
            title="Inbound Tracking Number"
            text={queryTuple.data.returnAuthorization?.inboundTrackingNumber} />
        </Grid>

        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="RMA Type"
            text={queryTuple.data.returnAuthorization?.rmaType} />

          <LabelledText.FC
            title="Days Open"
            text={queryTuple.data.returnAuthorization?.dateReceived.diffNow().negate().toFormat('d') + ' days'} />

          <LabelledText.FC
            title="RMA Reference Number"
            text={queryTuple.data.returnAuthorization?.referenceNumber} />
        </Grid>
      </Grid>
    </BaseWidget.FC>
  );
};
